import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import open_modal from '@/assets/modal/open_browser.webp';
import { GiftClose } from '@/components/icons/icons';
import BlurryLoadingImage from '@/components/progressive-img';
import useDevice from '@/hooks/useDevice';
import { modalStore } from '@/stores/modal';
import { isInFacebookBrowser } from '@/utils/utils';

import styles from './styles.module.less';

const OpenBrowser = () => {
  const { device } = useDevice();
  const pathname = useLocation();

  useEffect(() => {
    if (isInFacebookBrowser() && device === 'ios') {
      modalStore.setOpenBrowser();
    }
  }, [pathname]);

  return (
    <div className={styles.img_box}>
      <BlurryLoadingImage loading="lazy" src={open_modal} alt="" />
      <div className={styles.close_box}>
        <GiftClose
          className={styles.close}
          onClick={() => {
            modalStore.closeModal('open-browser-modal');
          }}
        />
      </div>
    </div>
  );
};

export default OpenBrowser;
